import { render, staticRenderFns } from "./gwgl.vue?vue&type=template&id=6d946b4c&"
import script from "./gwgl.vue?vue&type=script&lang=js&"
export * from "./gwgl.vue?vue&type=script&lang=js&"
import style0 from "./gwgl.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports